import { App } from 'vue'

import AppEmptyState from '@/common/AppEmptyState.vue'
import AppTextDivider from '@/common/AppTextDivider.vue'
import AppAlertInPage from '@/design-system/alert/AppAlertInPage.vue'
import AppAvatar from '@/design-system/AppAvatar.vue'
import AppSegmentedControl from '@/design-system/AppSegmentedControl.vue'
import AppBadge from '@/design-system/badge/AppBadge.vue'
import AppButton from '@/design-system/buttons/AppButton.vue'
import AppButtonAlert from '@/design-system/buttons/AppButtonAlert.vue'
import AppDropdownButton from '@/design-system/buttons/dropdown-button/AppDropdownButton.vue'
import AppDropdownButtonItem from '@/design-system/buttons/dropdown-button/AppDropdownButtonItem.vue'
import FileSizeDisplay from '@/design-system/display/FileSizeDisplay.vue'
import AppIcon from '@/design-system/icons/AppIcon.vue'
import AppIconBadge from '@/design-system/icons/AppIconBadge.vue'
import AppIconDs from '@/design-system/icons/AppIconDs.vue'
import AppRadioGroup from '@/design-system/inputs/AppRadioGroup.vue'
import AppToggle from '@/design-system/inputs/AppToggle.vue'
import AppTreeviewItem from '@/design-system/treeview/AppTreeviewItem.vue'
import AppHeadline from '@/design-system/typography/AppHeadline.vue'

export function globallyRegisterDesignSystemComponents (app: App) {
  // alert
  app.component('app-alert-in-page', AppAlertInPage)

  // buttons
  app.component('app-button', AppButton)
  app.component('app-button-alert', AppButtonAlert)
  app.component('app-dropdown-button', AppDropdownButton)
  app.component('app-dropdown-button-item', AppDropdownButtonItem)
  app.component('app-segmented-control', AppSegmentedControl)
  app.component('app-radio-group', AppRadioGroup)

  // badge
  app.component('app-badge', AppBadge)

  // display
  app.component('app-filesize-display', FileSizeDisplay)

  // icons
  app.component('app-icon', AppIcon)
  app.component('app-icon-ds', AppIconDs)
  app.component('app-icon-badge', AppIconBadge)

  // inputs
  app.component('app-toggle', AppToggle)

  // treeview
  app.component('app-treeview-item', AppTreeviewItem)

  // typography
  app.component('app-headline', AppHeadline)

  // misc
  app.component('app-avatar', AppAvatar)
  app.component('app-empty-state', AppEmptyState)
  app.component('app-text-divider', AppTextDivider)
}
